module.exports = __webpack_public_path__ + "img/ca.0d067fa0.svg";